import { ProductLineAPIService } from "./productLine";
import api from "../index";

export default new ProductLineAPIService(api);
